import { Container } from './styles'

export const InstitutionalText = () => {
  return (
    <Container.Main id='institutional'>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
            <span>Transforme sua carreira musical em um projeto financiado com execução profissional.</span>
          </h2>
        </Container.Title>
        <p>
          Sua comunidade apoia <br></br>
          A Fábrica realiza <br></br>
          Você cresce com estrutura, estratégia e qualidade
        </p>
      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2>
            O que é a <span>Fábrica Criativa?</span>
          </h2>
        </Container.Title>
        <p>A Fábrica Criativa é um ecossistema de desenvolvimento e gestão de carreira para artistas da música.<br></br>
        <br></br>
        Ajudamos você a organizar sua carreira como um negócio, com plano anual, estratégia clara e execução feita por uma equipe especializada.
        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2>
            O que é a <span>Jornada do Incubado?</span>
          </h2>
        </Container.Title>
        <p>
          A Jornada do Incubado é um acompanhamento anual dividido em fases que se conectam entre si. Cada fase tem entregas práticas e um planejamento estruturado.<br></br><br></br>


          <b style={{ fontWeight: 700 }}>Formação</b><br></br>
          Plano de negócio, plano de marketing, metas, direcionamento artístico e direcionamento  estratégico.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>Identidade Visual</b><br></br>
          Criação de marca, manual, registro no INPI e mapa de estilo.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>Redes Sociais e Marketing</b><br></br>
          Estratégia de conteúdo, gravações profissionais e tráfego pago.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>Voz e Performance</b><br></br>
          Aulas de canto, técnica, expressão e preparação para gravações.<br></br><br></br>


          <b style={{ fontWeight: 700 }}>Material de Show</b><br></br>
          Portfólio, fotos, ensaio dirigido e gravação do show.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>Lançamento Musical</b><br></br>
          Gravação de voz, audiovisual, capa e distribuição.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>Divulgação</b><br></br>
          Imprensa, influenciadores e campanhas promocionais.

        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
            Como funciona <span>a captação?</span>
          </h2>
        </Container.Title>
        <p>

          <b style={{ fontWeight: 700 }}>1. Inscrição</b><br></br>
          Você envia seu planejamento e informa o que precisa financiar.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>2. Avaliação</b><br></br>
          A equipe analisa se seu projeto pode ser executado com qualidade, dentro dos nossos prazos e processos.<br></br>

          Aprovamos apenas projetos que conseguimos realizar internamente.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>3. Link da campanha</b><br></br>
          Com o planejamento aprovado, você recebe um link Gooders para divulgar sua campanha.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>4. Apoio financeiro</b>
          Seus apoiadores contribuem com sua carreira e recebem recompensas pela plataforma Gooders.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>5. Execução pela Fábrica</b><br></br>
          Depois da meta atingida, a Fábrica executa todo o trabalho profissional previsto no seu planejamento.<br></br><br></br>

          <b style={{ fontWeight: 700 }}>6. Acompanhamento</b><br></br>
          Você e seus apoiadores acompanham as entregas e, ao final, recebem um relatório completo.

        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
            Como funcionam as <span>moedas Gooders?</span>
          </h2>
        </Container.Title>
        <p>

          Quando alguém doa para sua campanha, recebe moedas Gooders automaticamente.<br></br><br></br>
          ●	Cada 1 real doado gera 1 moeda.<br></br>

          ●	O apoiador pode trocar essas moedas por produtos, descontos ou benefícios na plataforma.<br></br>

          ●	Os valores de troca variam conforme cada parceiro.<br></br><br></br>

          As moedas pertencem ao apoiador e podem ser usadas quando quiser. Além disso, o apoiador recebe Certificado ESG de Sustentabilidade Corporativa


        </p>

      </Container.Box>


      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
           Como as <span>doações são usadas?</span>
          </h2>
        </Container.Title>
        <p>

          Toda doação é obrigatoriamente destinada aos serviços da Jornada do Incubado.<br></br>
          Isso garante:<br></br><br></br>
          ●	qualidade nas entregas<br></br>

          ●	respeito aos prazos<br></br>

          ●	uso correto do dinheiro<br></br>

          ●	transparência e prestação de contas<br></br><br></br>

          O artista e o apoiador ficam protegidos, e a carreira avança com segurança.


        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
           Objetivo da parceria <span>Fábrica Criativa + Gooders</span>
          </h2>
        </Container.Title>
        <p>

          Gerar mobilidade criativa<br></br>

          Transformar talento em projetos financiados, executados e publicados com transparência, impacto social e crescimento real para artistas da cena independente.


        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
           Regras <span>Essenciais</span>
          </h2>
        </Container.Title>
        <p>

        ●	Artistas da música (autoral ou intérprete)<br></br>

        ●	Escopo aprovado precisa ser executável pela Fábrica<br></br>

        ●	Campanha mínima: R$ 50.000,00<br></br>

        ●	Retirada mínima em serviços: R$ 2.500,00<br></br>

        ●	Verba vinculada às entregas aprovadas<br></br>

        ●	Cripto-recompensas: responsabilidade da Gooders<br></br>

        ●	Relatório final para apoiadores<br></br>

        ●	A comunidade “Família Criativa” pode ajudar a amplificar campanhas


        </p>

      </Container.Box>

      <Container.Box>
        <Container.Title>
          <h2 style={{ textAlign: 'left' }}>
          Planos Disponíveis para <span>Aplicação</span>
          </h2>
        </Container.Title>
        <p>

        <b style={{ fontWeight: 700 }}>Carreira Autoral – Meta de 150 mil</b><br></br>
        Para artistas autorais que querem construir uma carreira completa, com 4 lançamentos profissionais e um ano de acompanhamento.<br></br>
        Inclui:<br></br><br></br>
        ●	Plano de negócio e marketing<br></br>

        ●	Gestão estratégica<br></br>

        ●	Identidade visual completa<br></br>

        ●	Treino de voz<br></br>

        ●	Material de shows<br></br>

        ●	Redes sociais + gravações mensais (1 ano)<br></br>

        ●	Gravação de voz e vídeo<br></br>

        ●	Lançamento de 6 faixas<br></br>

        ●	Conteúdos de divulgação <br></br>

        ●	Marketing com divulgação<br></br><br></br>

        <b style={{ fontWeight: 700 }}>Carreira Cover – Meta de 72 mil</b><br></br>
        Para artistas covers que querem profissionalizar material, identidade e presença digital.<br></br>
        Inclui:<br></br><br></br>
        ●	Formação (negócio + marketing)<br></br>

        ●	Gestão estratégica<br></br>

        ●	Identidade visual<br></br>

        ●	Treino de voz<br></br>

        ●	Material de shows<br></br>

        ●	Redes sociais + gravações mensais (1 ano)<br></br>

        ●	Gravação de voz e vídeo<br></br><br></br>

        <b style={{ fontWeight: 700 }}>Hobby – Meta de 50 mil</b><br></br>
        Para artistas que querem iniciar presença digital profissional e ter material para shows.<br></br>
        Inclui:<br></br><br></br>
        ●	Formação (negócio + marketing)<br></br>

        ●	Material de shows<br></br>

        ●	Redes sociais + gravações mensais (1 ano)<br></br><br></br><br></br>


        <b style={{ fontWeight: 700 }}>Quer participar?</b><br></br>
        Envie sua aplicação para análise.<br></br>
        Se seu projeto for aprovado, você recebe seu link de campanha para iniciar sua captação.<br></br>


        </p>

      </Container.Box>

    </Container.Main>
  )
}
